import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class AttendanceResultAnomalyApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'attendance-result-anomaly'
    }

    public insert(param) {
        return this.send(param,"insert", this.Methods.POST)
    }



}